import { createContext, useContext } from 'react';
import { AmplitudeContextValue } from 'src/context/AmplitudeProvider/AmplitudeProvider.types';

export const AmplitudeContext = createContext<
  AmplitudeContextValue | undefined
>(undefined);

export const useAmplitude = () => {
  const context = useContext(AmplitudeContext);
  if (!context) {
    throw new Error('useAmplitude must be used within an AmplitudeProvider');
  }
  return context;
};
